import React, { useEffect, useState } from "react"
import { Accordion, AccordionDetails, AccordionSummary, Divider, Grid, Typography } from "@mui/material"
import { DrawerSeeker, IconSeeker } from "@ui-seeker/core"
import { isAutoEuropeDrawerOpen, autoEuropeDrawerData } from "Pages/AutoEuropeTool/Page/@signals"
import AutoEuropeDrawerFooter from "Pages/AutoEuropeTool/Page/@components/Footer"
import AutoEuropeName from "Pages/AutoEuropeTool/Page/@components/Name"
import AutoEuropeMinimumValueField from "Pages/AutoEuropeTool/Page/@components/MinimumValueField"
import AutoEuropeSeasonSetField from "Pages/AutoEuropeTool/Page/@components/SeasonSetField"
import AutoEuropeDurations from "Pages/AutoEuropeTool/Page/@components/DurationRange"
import AutoEuropeUndercut from "Pages/AutoEuropeTool/Page/@components/Undercut"
import AutoEuropeAgencyId from "Pages/AutoEuropeTool/Page/@components/AgencyId"
import AutoEuropeAgentId from "Pages/AutoEuropeTool/Page/@components/AgentId"
import AutoEuropeReports from "Pages/AutoEuropeTool/Page/@components/Reports"
import AutoEuropeExcludeOffices from "Pages/AutoEuropeTool/Page/@components/ExcludeOffices"
import AutoEuropeExcludeWebs from "Pages/AutoEuropeTool/Page/@components/ExcludeWebs"
import AutoEuropeExcludeWebSuppliers from "Pages/AutoEuropeTool/Page/@components/ExcludeWebSuppliers"
import AutoEuropeExcludeProviders from "Pages/AutoEuropeTool/Page/@components/ExcludeProviders"
import AutoEuropeFilterCategories from "Pages/AutoEuropeTool/Page/@components/FilterCategories"
import AutoEuropeFilterAcriss from "Pages/AutoEuropeTool/Page/@components/FilterAcriss"
import AutoEuropeInsurance from "Pages/AutoEuropeTool/Page/@components/Insurance"
import AutoEuropeCompareBy from "Pages/AutoEuropeTool/Page/@components/CompareBy"
import AutoEuropeTargetPosition from "Pages/AutoEuropeTool/Page/@components/TargetPosition"

function hasFilterData() {
	const d = autoEuropeDrawerData.peek()
	const hasIds = (f) => Array.isArray(f) && f.length > 0
	return hasIds(d.filterGroupOffices) || hasIds(d.filterGroupSites) || hasIds(d.filterGroupWebSuppliers) || hasIds(d.filterGroupProviders) || hasIds(d.filterCategories) || hasIds(d.filterAcriss)
}

export default function AutoEuropeDrawer({ onSubmit, isLoading }) {
	const isEdit = !!autoEuropeDrawerData.peek().id
	const isOpen = isAutoEuropeDrawerOpen.value
	const compareByCategory = autoEuropeDrawerData.value?.compareByCategory ?? false
	const [filtersOpen, setFiltersOpen] = useState(false)

	useEffect(() => {
		if (isOpen) setFiltersOpen(hasFilterData())
	}, [isOpen])

	return <DrawerSeeker
		title={isEdit ? autoEuropeDrawerData.peek().name : "Create AutoEurope Pricing Tool"}
		anchor="right"
		width="40%"
		variant="persistent"
		isOpen={isAutoEuropeDrawerOpen.value}
		customFooter={<AutoEuropeDrawerFooter onSubmit={onSubmit} isLoading={isLoading}/>}
	>
		<Grid container spacing={3}>
			<Grid item xs={12}>
				<AutoEuropeName/>
			</Grid>

			<Grid item xs={12}><Divider/></Grid>

			<Grid item xs={6}>
				<AutoEuropeMinimumValueField field="minimumMargin" label="Minimum Margin" placeholder="0" startIcon="percentage" max={100}/>
			</Grid>
			<Grid item xs={6}>
				<AutoEuropeMinimumValueField field="minimumProfit" label="Minimum Profit" placeholder="0.00" startIcon="money-bill" max={500}/>
			</Grid>

			<Grid item xs={12}><Divider/></Grid>

			<Grid item xs={12}>
				<AutoEuropeSeasonSetField/>
			</Grid>

			<Grid item xs={12}><Divider/></Grid>

			<Grid item xs={12}>
				<AutoEuropeDurations/>
			</Grid>

			<Grid item xs={12}><Divider/></Grid>

			<Grid item xs={12}>
				<AutoEuropeUndercut/>
			</Grid>

			<Grid item xs={12}><Divider/></Grid>

			<Grid item xs={6}>
				<AutoEuropeCompareBy/>
			</Grid>
			<Grid item xs={6} sx={{ display: 'flex', alignItems: 'flex-end' }}>
				<AutoEuropeTargetPosition/>
			</Grid>

			<Grid item xs={12}><Divider/></Grid>

			<Grid item xs={6}>
				<AutoEuropeAgencyId/>
			</Grid>
			<Grid item xs={6}>
				<AutoEuropeAgentId/>
			</Grid>

			<Grid item xs={12}><Divider/></Grid>

			<Grid item xs={12}>
				<AutoEuropeReports/>
			</Grid>

			<Grid item xs={12}><Divider/></Grid>

			<Grid item xs={12}>
				<AutoEuropeInsurance/>
			</Grid>

			<Grid item xs={12}><Divider/></Grid>

			<Grid item xs={12}>
				<Accordion
					expanded={filtersOpen}
					onChange={(_, expanded) => setFiltersOpen(expanded)}
					disableGutters
					elevation={0}
					sx={{ border: '1px solid', borderColor: 'divider', borderRadius: 1, '&:before': { display: 'none' } }}
				>
					<AccordionSummary expandIcon={<IconSeeker icon="chevron-down"/>}>
						<Typography variant="body2" sx={{ fontWeight: 600 }}>Optional Filters</Typography>
					</AccordionSummary>
					<AccordionDetails>
						<Grid container spacing={3}>
							<Grid item xs={12}>
								<AutoEuropeExcludeOffices/>
							</Grid>
							<Grid item xs={12}>
								<AutoEuropeExcludeWebs/>
							</Grid>
							<Grid item xs={12}>
								<AutoEuropeExcludeWebSuppliers/>
							</Grid>
							<Grid item xs={12}>
								<AutoEuropeExcludeProviders/>
							</Grid>
							{compareByCategory ? (
								<Grid item xs={12}>
									<AutoEuropeFilterCategories/>
								</Grid>
							) : (
								<Grid item xs={12}>
									<AutoEuropeFilterAcriss/>
								</Grid>
							)}
						</Grid>
					</AccordionDetails>
				</Accordion>
			</Grid>
		</Grid>
	</DrawerSeeker>
}